"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * development API of Digital Villages Platform
 * See digitale-doerfer-api.json (info.description) for more details
 *
 * The version of the OpenAPI document: See digitale-doerfer-api.json
 * Contact: support@digitale-doerfer.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function ClientAddressDefinitionFromJSON(json) {
    return ClientAddressDefinitionFromJSONTyped(json, false);
}
exports.ClientAddressDefinitionFromJSON = ClientAddressDefinitionFromJSON;
function ClientAddressDefinitionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'city': !runtime_1.exists(json, 'city') ? undefined : json['city'],
        'gpsLocation': !runtime_1.exists(json, 'gpsLocation') ? undefined : _1.GPSLocationFromJSON(json['gpsLocation']),
        'name': !runtime_1.exists(json, 'name') ? undefined : json['name'],
        'street': !runtime_1.exists(json, 'street') ? undefined : json['street'],
        'zip': !runtime_1.exists(json, 'zip') ? undefined : json['zip'],
    };
}
exports.ClientAddressDefinitionFromJSONTyped = ClientAddressDefinitionFromJSONTyped;
function ClientAddressDefinitionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'city': value.city,
        'gpsLocation': _1.GPSLocationToJSON(value.gpsLocation),
        'name': value.name,
        'street': value.street,
        'zip': value.zip,
    };
}
exports.ClientAddressDefinitionToJSON = ClientAddressDefinitionToJSON;
